if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    $('.reviews-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


        // //vanilla JS fancybox
        // if(document.getElementsByClassName('lightbox').length > 0){
        //     let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
        //     let allLightboxesLength = allLightboxes.length;

        //     for(let j = 0; j < allLightboxesLength; j++ ){
        //         allLightboxes[j].addEventListener('click', function(e){
        //             e.preventDefault();
        //             let currentTarget = this.getAttribute('href').split('#')[1];
        //             if(!document.getElementById(currentTarget).classList.contains('open')){
        //                 document.getElementById(currentTarget).classList.add('open')
        //             } else {
        //                 document.getElementById(currentTarget).classList.remove('open')
        //             }
        //         });
        //     }

        //     let allLightcloses = document.getElementsByClassName('js-lightboxclose');
        //     let allLightclosesLength = allLightcloses.length;

        //     for(let j = 0; j < allLightclosesLength; j++ ){
        //         allLightcloses[j].addEventListener('click', function(e){
        //             e.preventDefault();
        //             let currentTarget = this.parentElement.parentElement.id;
        //             if(!document.getElementById(currentTarget).classList.contains('open')){
        //                 document.getElementById(currentTarget).classList.add('open')
        //             } else {
        //                 document.getElementById(currentTarget).classList.remove('open')
        //             }
        //         });
        //     }
        // }



})();